// import React from "react";
// import { useNavigate } from "react-router-dom";
// import EntityTable from "../components/EntityTable";
// import { fkId } from "../utils/coreHelpers";

// export default function HospitalListTable({ hospitals }) {
//   const nav = useNavigate();

//   return (
//     <EntityTable
//       title="Hospitals List"
//       rows={hospitals}
//       getRowKey={(r) => fkId(r.hospital_id || r.id)}
//       columns={[
//         {
//           key: "name",
//           label: "Hospital Name",
//           render: (r) => (
//             <span
//               style={{ fontWeight: 900, cursor: "pointer" }}
//               onClick={() => nav(`/core/hospitals/${fkId(r.hospital_id || r.id)}`)}
//             >
//               {r.name}
//             </span>
//           ),
//         },
//         // { key: "org_type", label: "Type" },
//         { key: "city", label: "City" },
//         { key: "state", label: "State" },
//         // { key: "status", label: "Status" },
//       ]}
//     />
//   );
// }

import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import EntityTable from "../components/EntityTable";
import { fkId } from "../utils/coreHelpers";

/**
 * Responsive rules:
 * - 250px–600px: card list (no table)
 * - >600px: table with Name/City/State
 */
export default function HospitalListTable({ hospitals = [] }) {
  const nav = useNavigate();
  const theme = useTheme();

  const isSmall = useMediaQuery(theme.breakpoints.down("sm")); // <= 600
  const isUltraTight = useMediaQuery("(max-width:320px)"); // extra small phones

  // ✅ MOBILE (250–600): Card/List view (best for very small screens)
  if (isSmall) {
    return (
      <Box sx={{ width: "100%" }}>
        <Typography sx={{ fontWeight: 1000, mb: 1 }}>
          Hospitals List
        </Typography>

        <Stack spacing={1}>
          {(hospitals || []).map((r) => {
            const id = fkId(r.hospital_id || r.id);
            return (
              <Card key={id} variant="outlined" sx={{ borderRadius: 2 }}>
                <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
                  <Button
                    fullWidth
                    variant="text"
                    onClick={() => nav(`/core/hospitals/${id}`)}
                    sx={{
                      textAlign: "left",
                      justifyContent: "flex-start",
                      textTransform: "none",
                      fontWeight: 1000,
                      fontSize: isUltraTight ? 13 : 14,
                      lineHeight: 1.2,
                      p: 0,
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {r?.name || "-"}
                  </Button>

                  {/* Optional: show City/State in small text (NOT columns) */}
                  <Box sx={{ mt: 0.75, display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <Typography sx={{ fontSize: 12, opacity: 0.75 }}>
                      {r?.city || "-"}
                    </Typography>
                    <Typography sx={{ fontSize: 12, opacity: 0.75 }}>
                      {r?.state || "-"}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      </Box>
    );
  }

  // ✅ DESKTOP/TABLET (>600): Table view
  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <EntityTable
        title="Hospitals List"
        rows={hospitals}
        getRowKey={(r) => fkId(r.hospital_id || r.id)}
        columns={[
          {
            key: "name",
            label: "Hospital Name",
            render: (r) => {
              const id = fkId(r.hospital_id || r.id);
              return (
                <Button
                  variant="text"
                  onClick={() => nav(`/core/hospitals/${id}`)}
                  sx={{
                    fontWeight: 900,
                    textTransform: "none",
                    p: 0,
                    minWidth: 0,
                    justifyContent: "flex-start",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {r?.name || "-"}
                </Button>
              );
            },
          },
          { key: "city", label: "City", render: (r) => r?.city || "-" },
          { key: "state", label: "State", render: (r) => r?.state || "-" },
        ]}
      />
    </Box>
  );
}